import thumbsUp from '../../assets/images/thumbs_up.png'
import clappingHands from '../../assets/images/clapping_hands.png'
import thinkingFace from '../../assets/images/thinking_face.png'
import redHeart from '../../assets/images/red_heart.png'
import cryingLaughing from '../../assets/images/crying_laughing.png'
import partyPopper from '../../assets/images/party_popper.png'
//
// EMOJIS SHOULD BE SNAKE CASED TO PASS VALIDATION ON THE BACKEND
//

interface EmojiReactions {
  [key: string]: string
}

export const emojiReactions: EmojiReactions = {
  thumbs_up: thumbsUp,
  clapping_hands: clappingHands,
  red_heart: redHeart,
  crying_laughing: cryingLaughing,
  thinking_face: thinkingFace,
  party_popper: partyPopper,
}
